import * as React from 'react'
import type { SVGProps } from 'react'
export interface Message2HeartIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string
}
/**
 * message-2-heart
 * Tabler Icons
 * @url https://icon-sets.iconify.design/tabler
 * @license MIT
 */
export const Message2HeartIcon = (props: Message2HeartIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M8 9h8m-8 4h3.5m-1 6.5L9 18H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v4" />
        <path d="m18 22l3.35-3.284a2.143 2.143 0 0 0 .005-3.071a2.24 2.24 0 0 0-3.129-.006l-.224.22l-.223-.22a2.24 2.24 0 0 0-3.128-.006a2.143 2.143 0 0 0-.006 3.071z" />
      </g>
    </svg>
  )
}
